import { HeartCommon } from "@components";
import { selectFavoriteTours, updateFavorite, useAppDispatch, useAppSelector } from "@redux";
import { PATH_LOGIN } from "@routes";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorToast } from "src/Components/toasts/ErrorToast";
import { SuccessToast } from "src/Components/toasts/SuccessToast";

interface HeartTourModuleProps {
    productId: string | number;
}

export const HeartTourModule = ({ productId }: HeartTourModuleProps) => {
    const dispatch = useAppDispatch();
    const favoriteState = useAppSelector(selectFavoriteTours);
    const { tours, loading } = favoriteState;
    const authJWT = useAppSelector((state) => state.auth.jwt);
    const account = useAppSelector((state) => state.account.account);
    const navigate = useNavigate();
    const location = useLocation();
    const shouldShowLoading = loading && !_.isNil(authJWT) && !_.isNil(account);

    const liked =
        tours?.some(
            (tour) =>
                (tour?.tdms_product_id ?? tour?.productId)?.toString() === productId.toString(),
        ) ?? false;

    const handleToggle = () => {
        if (!authJWT || !account) {
            ErrorToast({ Message: "Please login first to add favorites" });
            const returnPath = encodeURIComponent(location.pathname + location.search);
            navigate(`${PATH_LOGIN}?returnPath=${returnPath}`);
            return;
        }
        if (shouldShowLoading) return;
        const method = liked ? 0 : 1;
        dispatch(updateFavorite({ productId, method })).then(() => {
            SuccessToast({ Message: liked ? "Removed from favorites" : "Added to favorites" });
        });
    };

    return <HeartCommon active={liked} loading={shouldShowLoading} onClick={handleToggle} />;
};
